export default "__VITE_ASSET__07370e39__"